import { twMerge } from "tailwind-merge"
const Heading2: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({ className, children, ...props }) => {
  return (
    <h2
      className={twMerge("font-bricolage font-extrabold text-[2.25rem] md:text-[3rem] leading-[100%]", className)}
      {...props}>
      {children}
    </h2>
  )
}

export default Heading2
